import React from "react";

const DynamicVoiceInterviewThankYou = ({ logoSrc }) => {
  return (
    <div className="thankyou-wrapper">
      <div className="thankyou-card">
        <img src={logoSrc || "/images/gappeoai-logo.png"} alt="Gappeo AI" className="thankyou-logo" />
        <div className="thankyou-icon">
          <svg viewBox="0 0 24 24" fill="none" width="56" height="56">
            <circle cx="12" cy="12" r="11" stroke="#02c573" strokeWidth="2" />
            <path
              d="M7 12.5l3.5 3.5 6.5-7"
              stroke="#02c573"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <h2 className="thankyou-heading">Thank You for Attending the Interview</h2>
        <p className="thankyou-body">
          We appreciate the time and effort you dedicated to this session. Our team will
          carefully review your responses and reach out to you with the next steps shortly.
        </p>
        <p className="thankyou-close">You may now safely close this window.</p>
      </div>
    </div>
  );
};

export default DynamicVoiceInterviewThankYou;
